import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["LandingContact"] */ "/vercel/path0/src/app/willkommen/einfuehrung/landing-contact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CountUp"] */ "/vercel/path0/src/components/CountUp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleMap"] */ "/vercel/path0/src/components/GoogleMap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AllInOne"] */ "/vercel/path0/src/components/home/AllInOne.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQAccordion"] */ "/vercel/path0/src/components/home/FAQAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IntroVideo"] */ "/vercel/path0/src/components/home/IntroVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LatestBlogsGrid"] */ "/vercel/path0/src/components/home/LatestBlogsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogoSliderClient"] */ "/vercel/path0/src/components/home/LogoSliderClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServicesPreview"] */ "/vercel/path0/src/components/home/ServicesPreview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsCarousel"] */ "/vercel/path0/src/components/home/testimonials-carousel.tsx");
